<template>
  <el-row class="warp" style="height: 100%;width: 100%;">
    <el-tabs
      class="roleManagerTabBox product_management_box"
      v-model="activeName"
    >
      <el-tab-pane name="first">
        <span slot="label" style="padding: 0 15px">平台名称配置</span>
        <div class="product_tab_1 outer_tab">
          <bigScreenTitleBorder :title="'查询条件'"></bigScreenTitleBorder>
          <div 
            class="pulldownbox info-container"
            v-show="!showQueryFilter"
          >
            <i class="el-icon-info"></i>
            <span>查询条件</span>
            <span class="pulldownbtn" @click="pulldown"
              >展开<i class="el-icon-arrow-down"></i
              ></span>
          </div>
            <!--展开内容-->
          <div 
            style="width: 100%;padding-bottom:8px;"
            class="expandbox info-container"
            v-show="showQueryFilter"
          >
            <el-form 
              class="product_filter_form"
              :model="filterForm"
              inline
              ref="filterForm"
              size="small"
              label-width="110px"
            >
              <el-form-item label="区域:" prop="tkObj">
                <!--县乡村 联动-->
                <el-cascader
                  class="textInput"
                  size="small"
                  v-model="filterForm.qhdm"
                  @change="liandong"
                  :options="areaOptions"
                  :props="areaProps"
                  collapse-tags
                    :show-all-levels="false"
                >
                </el-cascader>
              </el-form-item>
              <el-form-item label="机构名称:" prop="departmentName">
                <el-select ref="workList" v-model="filterForm.departmentName" filterable>
                <el-option
                  v-for="item in workList"
                  :key="item.number"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
              </el-form-item>
              <br>
            </el-form>
            <el-row style="text-align: center;margin: 5px 0;">
              <el-button @click="queryBtnClick" type="primary" size="small">查询</el-button>
              <el-button @click="resetFilter" type="primary" plain size="small">重置</el-button>
              <span class="pullupbtn" @click="pullup">收起<i class="el-icon-arrow-up"></i></span>
            </el-row>
          </div>
          <div class="tablebox info-container" style="height:calc(100% - 20px);">
            <bigScreenTitleBorder :title="'配置列表'"></bigScreenTitleBorder>
            <el-row :span="24" class="toolbar" style="height: 44px;line-height:44px;text-align:right;padding-right:10px;">
              <el-col>
                <el-button type="primary" size="small " @click="handleAdd">新增</el-button>
              </el-col>
            </el-row>
            <div class="table-container">
                <el-table :data="dataList" height="100%" highlight-current-row
                    v-loading="loading" ref="cropDom" class="gl-el-table-box product_tab_1_table"
                >
                  <el-table-column style="padding-left: 13px" label="序号" align="center"  width="100" type="index"></el-table-column>
                  <el-table-column label="区划代码"  width="200" prop="qhdm"></el-table-column>
                  <el-table-column label="区划名称" prop="qhmc">
                  </el-table-column>
                  <el-table-column label="机构名称" prop="departmentName">
                  </el-table-column>
                  <el-table-column label="平台名称" prop="name"></el-table-column>
                  <el-table-column label="操作" align="center" fixed="right" width="100">
                    <template slot-scope="scope">
                      <el-tooltip class="item" content="设置" placement="top">
                        <i class="table-icon el-icon-setting" @click="delHandler(scope.row)"></i>
                      </el-tooltip>
                      <!-- <el-button type="info" plain size="mini" @click="delHandler(scope.row)">删除</el-button> -->
                    </template>
                  </el-table-column>
                </el-table>
            </div>
            <!--分页工具-->
        <el-row class="page-row">
          <el-pagination
            background
            :page-size="pageSize"
            :current-page.sync="currentPage"
            @current-change="currentChange"
            layout="prev, pager, next, jumper"
            :total="totalItems"
          >
          </el-pagination>
        </el-row>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
      <!-- <div class="product_management_boxNew">
        <div class="product_management_content">
        </div>
      </div> -->
            <!-- 弹窗 -->
            <colocate-popup @dicApplicationUpdate="dicApplicationUpdate"></colocate-popup>
  </el-row>
</template>

<script>
  import API from "../../../api/configuration/api_configuration"
  import Cookies from 'js-cookie'
  import API_dic from "@/api/api_common";
  import colocatePopup from './popup/colocate-popup'
  export default {
    components:{
      colocatePopup,
    },
    data(){
      return {
        areaCode: Cookies.get('curAreaCode'),
        areaName: Cookies.get('curAreaName'),
        qhdm: Cookies.get('curAreaCode'),
        qhmc: Cookies.get('curAreaName'),
        currentPage: 1 /*分页工具当前选中页*/,
        pageSize: 10,
        totalItems: 0 /*数据总条数*/,
        // areaCode: Cookies.get('curAreaCode'),
        areaOptions: [],
        areaProps: {
          label: 'qhmc',
          value: 'qhdm',
          children: 'children',
          checkStrictly: true,
          lazy: true,
          lazyLoad (node, resolve) {
            setTimeout(() => {
              let nodes;
              if(node.children.length>0){
                nodes = []
                resolve(nodes);
              }else{
                API_dic.getSubArea({qhdm: node.value}).then(res=>{
                  nodes = res.data
                  // if(node.value.length==6){
                    nodes.forEach(item=>{
                      if(item.qhdm.length==6){
                        item.leaf = true
                      }
                    })
                  // }
                  resolve(nodes);
                })
              }
              // 通过调用resolve将子节点数据返回，通知组件数据加载完成
              // resolve(nodes);
            }, 300);
          }
        },
        dataList:[],
        workList:[],
        loading: false,
        activeName: 'first',
        showQueryFilter: true, /*是否显示搜索条件*/
        filterForm: {
          qhdm:[Cookies.get('curAreaCode')],
          departmentName: '',
        },
      }
    },
    created(){
      this.queryBtnClick();
      this.getNextXzqData();
      this.GLOBAL.eventBus.$on("refreshColorateList",this.refreshColorateList);
      // this.GLOBAL.eventBus.$on("areaOptionsCompleted",this.getNextXzqData);
      this.departmentAll()
    },
    methods:{
      dicApplicationUpdate(val){
        console.log("val",val)
          this.queryBtnClick()
      },
      liandong :function (obj) {
        // this.qhdm = obj[obj.length - 1]
        // this.queryBtnClick();
      },
      refreshColorateList(){
        // this.qhdm = this.areaCode;
        // this.filterForm.qhdm=this.areaCode
        // this.queryBtnClick();
      },
      /*分页工具换页*/
    currentChange(val) {
      this.currentPage = val;
      this.params.page = val;
      this.getDataList();
    },
      /*点击查询按钮*/
      queryBtnClick() {
        this.params = {
          "qhdm":this.filterForm.qhdm[this.filterForm.qhdm.length-1]==1?'':this.filterForm.qhdm[this.filterForm.qhdm.length-1],
          'departmentName':this.filterForm.departmentName,
           page: this.currentPage, // 页数
        };
        this.getDataList();
      },
      async getDataList(){
        let that = this;
        try {
            that.loading = true;
            let res = await API.dicApplicationList(this.params);
            // let res = await API.getColocationList({qhdm:"2110"});
            if(res.code === 0 && res.data){
              // const list = res.data.list;
              // if(list.qhdm.length.length<6) list.hasChildren=true;
              // const subList = list.subList;
              // subList.forEach(item=>{
              //   if(item.qhdm.length<6) item.hasChildren=true;
              // })
              that.dataList = res.data.list;
              that.totalItems=res.data.count
            }else{list
              that.GLOBAL.warning(res.msg || "获取数据失败!");
            }
          }catch (e) {
            console.error("获取数据失败")
          }finally {
            that.loading=false
          }
      },
      departmentAll(){
        const params = {qhdm: this.areaCode};
        API.dicApplicationCheck(params).then(res=>{
          console.log("res",res)
          if(res.code===0){
            this.workList =res.data.list
          }
        })
      },
      /*点击重置按钮*/
      resetFilter() {
        // this.filterForm.qhdm = [this.areaCode]
        this.filterForm.qhdm = [Cookies.get('curAreaCode')]
       this.filterForm.departmentName=''
        this.queryBtnClick()
      },
      /*获取查询条件数据*/
      /*初始化行政区*/
      getNextXzqData(){
        if (this.areaCode) {
          this.areaOptions = [{
            qhdm: this.areaCode,
            qhmc: this.areaCode==1?'全国':this.areaName,
            children: null,
            leaf: this.areaCode.length>=6
          }]
        }else{
          this.areaOptions = []
        }
      },
      handleAdd(){
        this.GLOBAL.eventBus.$emit("show_colorate_dialog");
      },
      delHandler(row){
        let that = this;
        console.log(row);
        this.GLOBAL.eventBus.$emit("show_colorate_dialog",{
          qhdm:row.qhdm,
          id:row.id,
          departmentName:row.departmentName,
          departmentNumber:row.departmentNumber,
          name:row.name,
          qhmc:row.qhmc,
          update:true,
        });
        // this.$confirm("确认删除该记录吗?", "提示", { type: "warning" })
        //   .then(() => {
        //     that.loading = true;
        //     var params = {
        //       dicAreaNumber: row.dicAreaNumber
        //     };
        //     API.delColocation(params)
        //       .then(
        //         function(result) {
        //           that.loading = false;
        //           if (result && parseInt(result.code) === 0) {
        //             that.$message.success({
        //               showClose: true,
        //               message: "删除成功",
        //               duration: 1500
        //             });
        //             that.getDataList();
        //           }
        //         },
        //         function(err) {
        //           that.loading = false;
        //           that.$message.error({
        //             showClose: true,
        //             message: err.toString(),
        //             duration: 2000
        //           });
        //         }
        //       )
        //       .catch(function(error) {
        //         that.loading = false;
        //         // console.log(error);
        //         that.$message.error({
        //           showClose: true,
        //           message: "请求出现异常",
        //           duration: 2000
        //         });
        //       });
        //   })
        //   .catch(() => {});
      },
      /*收起按钮*/
      pullup() {
        this.showQueryFilter = false;
      },

      /*展开按钮*/
      pulldown() {
        this.showQueryFilter = true;
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/studio/systemConfig/nameConfiguration/main.vue